import { useState, useEffect, useRef } from 'react';
import { ReviewItem } from '@/types/api';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/atoms/PcTooltip';
import ImageDialog from './ImageDialog';

const ReviewBody = ({ review }: { review: ReviewItem }) => {
  const hasImage = review.AttachmentList && review.AttachmentList.length > 0;

  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // truncate 체크 함수
  const checkTruncate = () => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  };

  useEffect(() => {
    checkTruncate();
    window.addEventListener('resize', checkTruncate);
    return () => {
      window.removeEventListener('resize', checkTruncate);
    };
  }, [review.ProductName]);

  return (
    <div className="flex w-full flex-col gap-[12px]">
      <div className="flex w-full flex-col gap-[4px]">
        <ProductName review={review} />
        <div className="w-full break-all text-gr-700 Body5M14">{review.Content}</div>
      </div>
      {hasImage && <ImageDialog review={review} />}
    </div>
  );
};

export default ReviewBody;

const ProductName = ({ review }: { review: ReviewItem }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // truncate 체크 함수
  const checkTruncate = () => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  };

  useEffect(() => {
    checkTruncate();
    window.addEventListener('resize', checkTruncate);
    return () => {
      window.removeEventListener('resize', checkTruncate);
    };
  }, [review.ProductName]);

  return (
    <div className="w-full">
      <TooltipProvider>
        {isTruncated ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                ref={textRef}
                className="w-full truncate text-[15px] font-medium leading-[22px]  text-gr-800"
              >
                {review.ProductName}
              </div>
            </TooltipTrigger>
            <TooltipContent>{review.ProductName}</TooltipContent>
          </Tooltip>
        ) : (
          <div
            ref={textRef}
            className="w-full truncate text-[15px] font-medium leading-[22px] text-gr-800"
          >
            {review.ProductName}
          </div>
        )}
      </TooltipProvider>
    </div>
  );
};
